import React from 'react';
import BankIdIcon from '@tradera/blueprint/theme/icons2/bankid.svg?jsx';
import { classNames } from 'tradera/utils/class-names';

const BANK_ID_COLOR = '#183E4F'; // https://www.bankid.com/en/utvecklare/varumaerke/varumaerke-logotypen

export const BankIdLogoColor = ({
    className,
    ...props
}: React.SVGAttributes<SVGElement>) => {
    return (
        <BankIdIcon
            className={classNames('icon', className)}
            color={BANK_ID_COLOR}
            {...props}
        />
    );
};
